import React from 'react';
import PropTypes from 'prop-types';
import { Header } from 'semantic-ui-react';
import Card from '../../components/CoPayCard';
import Footnotes from '../../components/Footnotes';
import CallToAction from '../../components/CallToAction';
import Breadcrumbs from '../../components/Breadcrumbs';
import UnexpectedError from '../../components/UnexpectedError';

const Finish = (props) => {
  let content;
  let patientImageClass = '';

  // 406 - disqualified
  // 409 - already enrolled
  // 500 - server error
  if (props.enrollmentError) {
    if (props.enrollmentError === 409) {
      patientImageClass = 'smaller-patient-image';
      content = (() => {
        return (
          <div className="already-enrolled">
            <Header as="h1">
                Thank you for your request
            </Header>
            <div className="red-box ok">
              <p className="mb-0">You are <b>already enrolled</b> in the Takeda Oncology Co-Pay Assistance Program.</p>
            </div>
            <CallToAction id={ 4 }/>
          </div>
        );
      })();
    } else {
      content = (() => {
        return <UnexpectedError error={ props.enrollmentError } />;
      })();
    }
  }

  // active, inactive, pending, not eligible (not eligible will replace inactive/pending)
  if (props.enrollmentStatus) {
    switch (props.enrollmentStatus) {
      case 'ACTIVE':
        content = (() => {
          return (
            <div className="success">
              <Header as="h1">
                You have successfully enrolled. Thank you!
              </Header>
              <p><b>You will receive a letter in the mail that contains the Takeda Oncology Co-Pay Card.*</b></p>
              <br/>
              <p>Below is an image of the card you will be receiving. Please print a copy of the card below, or write down the card information. You may need this information to fill a prescription before the card arrives in the mail. Provide this information to the pharmacist filling your Takeda Oncology prescription. Using this card you could pay as little as $0 per prescription.</p>
              <Card selectedProduct={ props.environment } cardBin={ props.cardBin } cardPcn={ props.cardPcn } cardId={ props.cardId } groupId={ props.groupId } className={ `track track-81 track-env-${props.environment}` }/>
              <Footnotes footnotes={ [2.5, 3, 4] }/>
            </div>
          );
        })();
        break;
      case 'INACTIVE':
      case 'PENDING':
      case 'NOT ELIGIBLE':
        content = (() => {
          patientImageClass = 'smaller-patient-image';
          return (
            <div className="pending-verification">
              <Header as="h1">
                  Pending verification of your insurance
              </Header>
              <div className="red-box time">
                <p>Sorry we are still processing your request. More information may be required. Please call <strong>1&#8209;855&#8209;902&#8209;6725</strong> for further assistance.</p>
                <div>
                  <p>Please use the below reference ID number when calling.</p>
                  <p className="pending-id-number"><b>Reference ID Number = {props.cardId}</b></p>
                </div>
              </div>
              <CallToAction id={ 4.5 }/>
            </div>
          );
        })();
        break;
      default:
        content = <UnexpectedError code="Something went wrong" />;
    }
  }

  return (
    <div className={ `sign-up full-width finish ${patientImageClass || ''}` }>
      <Breadcrumbs activeIndex={ 2 } />
      <div className="wrapper">
        { content }
      </div>
    </div>
  );
};

Finish.propTypes = {
  environment: PropTypes.string.isRequired,
  cardId: PropTypes.string,
  cardBin: PropTypes.string,
  cardPcn: PropTypes.string,
  groupId: PropTypes.string,
  enrollmentStatus: PropTypes.string,
};

export default Finish;
